import React, { useEffect, useState } from 'react';
import { peicarLogoSVG } from '../../../Assets/Images';
import { headerCotCSS } from './Headercotizador.css';
import { Link, useNavigate } from 'react-router-dom';
import { BsSearch } from 'react-icons/bs';
import { RxHamburgerMenu } from 'react-icons/rx';
import { SideMenu } from '../../../Components/Header/SideMenu/SideMenu';

function HeaderCotizador({actualStep = 1}) {
    const navigateTo = useNavigate();
    const [showSidebar, setShowSidebar] = useState(false);
    const [actualStepNumber, setActualStepNumber] = useState(1); // it is actualStep but only when actualStep is a number

    useEffect(()=>{
        if(typeof actualStep !== "string")
            setActualStepNumber(actualStep);

    }, [actualStep])

    function goHome(section){
        navigateTo("/" + section)
    }
    
    return (
        <div id="HeaderCotizador" css={headerCotCSS(actualStepNumber * 25, actualStepNumber)}>
            <div className="Container">
                <div className="Left GridItem Pointer">
                    <img src={peicarLogoSVG} onClick={()=>navigateTo('/')} />
                </div>

                <div className="Center GridItem">
                    <div className="ProgressIndicator">

                        {/* PASO 1 */}
                        <div className={"Step"}>
                            1<span className="ConditionallyHidden1">. Elige tu auto</span>
                        </div>

                        {/* PASO 2 */}
                        <div className={"Step " + (actualStepNumber >= 2 ? '' : 'Inactive' )}>
                            2<span className="ConditionallyHidden2">. Obtén tu cotización</span>
                        </div>

                        {/* PASO 3 */}
                        <div className={"Step " + (actualStepNumber >= 3 ? '' : 'Inactive' )}>
                            3<span className="ConditionallyHidden3">. Solicitud</span>
                        </div>

                        {/* PASO 4 */}
                        <div className={"Step " + (actualStepNumber >= 4 ? '' : 'Inactive' )}>
                            4<span className="ConditionallyHidden4">. Estrena</span>
                        </div>

                        {/* PASO 5 */}
                        {/* <div className={"Step " + (actualStepNumber >= 5 ? '' : 'Inactive' )}>
                            5<span className="ConditionallyHidden5">. Estrena</span>
                        </div> */}

                        <div className="ColorBar"
                        ></div>
                    </div>
                </div>

                <div className="Right GridItem">
                    <div className="Nav">
                        <span>
                            <Link to="/">
                            Home
                            </Link>
                        </span>

                        <span onClick={()=>goHome("hablemos")}>
                           
                            Hablemos
                          
                        </span>
                    </div>

                    <div className="SideMenuContainer">
                        <RxHamburgerMenu 
                            className='Icon'
                            onClick={() => setShowSidebar(true)} 
                        />
                        <SideMenu
                            visible={showSidebar}
                            setVisible={setShowSidebar}
                        >

                            <nav className='MobileNav'>
                                <span onClick={()=>goHome("producto")}>
                                    Producto
                                </span>

                                <span onClick={()=>goHome("conoce")}>
                                    Con&oacute;cenos
                                </span>

                                <span onClick={()=>goHome("proceso")}>
                                    Proceso
                                </span>

                                <span onClick={()=>goHome("hablemos")}>
                                    Hablemos
                                </span>
                            </nav>
                        </SideMenu>
                    </div>
                </div>
            </div>
        </div>
    );
}

export {HeaderCotizador};